/** Hub SPA release label — GitHub source of truth after Mac wipe recovery. */
export const HUB_VERSION = "V26.2.225";
